/* =====================================================================
   LadeSue — motion
   One IntersectionObserver for reveals, one passive scroll listener
   behind requestAnimationFrame for parallax and the progress bar.
   Parallax runs on phones too, at a smaller amplitude.
   ===================================================================== */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.addEventListener('DOMContentLoaded', function () {
    var mobile = window.matchMedia('(max-width: 900px)').matches;

    /* ---------------------------------------------------------------
       Split headings into words so each can rise independently.
       Only top-level text nodes are split; an <em> is treated as one
       unit so the italic line stays intact.
       --------------------------------------------------------------- */
    function splitWords(el) {
      if (el.dataset.split) return;
      var out = [];
      Array.prototype.forEach.call(el.childNodes, function (node) {
        if (node.nodeType === 3) {
          node.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part.trim()) { out.push(document.createTextNode(part)); return; }
            var w = document.createElement('span'); w.className = 'w';
            var i = document.createElement('span'); i.className = 'wi';
            i.textContent = part; w.appendChild(i); out.push(w);
          });
        } else if (node.nodeType === 1) {
          var w = document.createElement('span'); w.className = 'w';
          var i = document.createElement('span'); i.className = 'wi';
          i.appendChild(node.cloneNode(true)); w.appendChild(i); out.push(w);
        }
      });
      el.innerHTML = '';
      out.forEach(function (n) { el.appendChild(n); });
      el.querySelectorAll('.wi').forEach(function (n, idx) {
        n.style.setProperty('--d', (idx * (mobile ? 0.05 : 0.07)).toFixed(2) + 's');
      });
      el.classList.add('m-words');
      el.dataset.split = '1';
    }

    document.querySelectorAll(
      '.hero-copy h1, .section-head h2, .story-copy h2, .sizeband h2, .news h2, .coll-head h1'
    ).forEach(splitWords);

    /* ---------- media: settle then breathe ---------- */
    document.querySelectorAll('.hero-media, .story-media, .cat, .pdpcar-wrap, .cats .cat')
      .forEach(function (el) {
        if (el.querySelector('img') || el.querySelector('.fill')) el.classList.add('m-media');
      });
    document.querySelectorAll('.hero-media, .story-media').forEach(function (el) {
      el.classList.add('m-breathe', 'm-par');
    });

    /* ---------- stagger any grid of cards ---------- */
    document.querySelectorAll('.prods, .cats').forEach(function (grid) {
      grid.classList.add('m-stagger');
      Array.prototype.forEach.call(grid.children, function (child, i) {
        child.style.setProperty('--d', (i * (mobile ? 0.06 : 0.09)).toFixed(2) + 's');
      });
    });

    /* ---------- one observer ---------- */
    var watch = document.querySelectorAll(
      '.m-words, .m-media, .m-stagger, .assure-inner, .sizetable, .quote blockquote'
    );
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    watch.forEach(function (el) { io.observe(el); });

    requestAnimationFrame(function () {
      watch.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.95) {
          el.classList.add('is-in'); io.unobserve(el);
        }
      });
    });

    /* ---------- progress hairline ---------- */
    var bar = document.createElement('div');
    bar.className = 'progress';
    document.body.appendChild(bar);

    /* ---------- parallax + header state ---------- */
    var layers = Array.prototype.slice.call(document.querySelectorAll('.m-par'));
    var header = document.querySelector('.site-header');
    var amp = mobile ? 0.05 : 0.11;      /* gentler on a small screen */
    var ticking = false;

    function frame() {
      var y = window.scrollY || 0;
      var vh = window.innerHeight;
      var doc = document.documentElement.scrollHeight - vh;

      bar.style.setProperty('--sp', doc > 0 ? Math.min(y / doc, 1).toFixed(4) : 0);
      if (header) header.classList.toggle('condensed', y > 80);

      layers.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;   /* offscreen, skip */
        var target = el.querySelector('img') || el.querySelector('.ph');
        if (!target) return;
        var progress = (vh - r.top) / (vh + r.height);      /* 0 to 1 through view */
        var shift = (progress - 0.5) * r.height * amp;
        target.style.setProperty('--py', shift.toFixed(1) + 'px');
      });

      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();
  });
})();
